import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { ToasterService } from '../../shared/services/toaster.service';
import { Application } from '../../../enums/application.enums';
import { environment } from '../../../../environments/environment';
import { catchError, map } from 'rxjs/operators';
import { Messages } from '../../../enums/messages.enums';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class WalletService {
  public creditCardUpdate = new Subject<boolean>();
  walletCountUpdate = new BehaviorSubject(null);

  constructor(
    private readonly http: HttpClient,
    private readonly ts: ToasterService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  public getJson_Bank(): Observable<[] | {}> {
    return this.http.get('../../../assets/Json/US_bank.json');
  }

  public getJson_Country(): Observable<[] | {}> {
    return this.http.get('../../../assets/Json/US_country.json');
  }

  /**
   * @description Multipart request (form data)
   * @param type  Request type
   * @param apiName  API end point
   * @param showLoader Loader status
   * @param bearerToken Bearer Token
   * @param data Request data.
   */
  stripeFormRequest(
  type: string,
  apiName: string,
  showLoader: boolean,
  data?: any,
  isFileUpload: boolean = false
): Observable<any> {
  if (showLoader === true) {
  }

  // Clone headers so we don't mutate the shared object
  let headers = new HttpHeaders().set('Authorization', `Bearer ${environment.stripeConfig.key}`);

  // DON'T set Content-Type for FormData
  if (!isFileUpload) {
    headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
  }

  const formOptions = {
    headers,
  };

  if (this.isOnline() && type === Application.TYPE_POST) {
    return this.callStripePostTypeAPI(apiName, data, showLoader, formOptions);
  }

  return new Observable();
}

  callStripePostTypeAPI(apiName, data, showLoader, headerOpt) {
    return this.http
      .post(`${environment.stripeConfig.file_url}${apiName}`, data, headerOpt)
      .pipe(
        map((res) => {
          if (showLoader) {
          }
          return res;
        }),
        catchError((error) => {
          if (showLoader) {
          }
          return throwError(() => error);
        })
      );
  }

  isOnline(): boolean {
    let status = false;
    if (isPlatformBrowser(this.platformId)) {
      if (window?.navigator?.onLine) {
        status = true;
      } else {
        this.ts.showWarning(Messages.INTERNET_CONNECTION_ERROR);
      }
    } else {
      status = true;
    }
    return status;
  }

  spaceValidator(control: AbstractControl): ValidationErrors | null {
    if (control && control.value && !control.value.replace(/\s/g, '').length) {
      control.setValue('');
      return { required: true };
    } else {
      return null;
    }
  }
}
